// extracted by mini-css-extract-plugin
export default {"features":"FeatureBlockAssistant_features__FgVdE","featuresItem":"FeatureBlockAssistant_featuresItem__U34Of","dropdownItem":"FeatureBlockAssistant_dropdownItem__ewyBL"};